export const AUTH_REQUEST = 'api/v2/oauth2/tokens';
export const GET_TRACK_ID_REQUEST = 'api/v1/oauth2/tracks';
export const CF_LOGIN_URL = 'api/v2/choco/login/';
